// src/services/api.js
import axios from 'axios';

export const GAS_URL = process.env.REACT_APP_GAS_URL || 'https://script.google.com/macros/s/SEU_ID_AQUI/exec';

// Aguarda N milissegundos
const sleep = (ms) => new Promise(r => setTimeout(r, ms));

// GET com retry automático (resolve cold start do GAS)
const request = async (action, data = {}, tentativas = 3) => {
  for (let i = 0; i < tentativas; i++) {
    try {
      const params = new URLSearchParams({ action, ...data });
      const response = await fetch(`${GAS_URL}?${params.toString()}`, {
        method: 'GET',
        redirect: 'follow',
        signal: AbortSignal.timeout(20000),
      });
      // Se retornou HTML (cold start / 404), tenta de novo
      const text = await response.text();
      if (text.trim().startsWith('<')) {
        throw new Error('GAS retornou HTML — cold start');
      }
      return JSON.parse(text);
    } catch (error) {
      console.warn(`[API] Tentativa ${i + 1}/${tentativas} falhou para "${action}":`, error.message);
      if (i < tentativas - 1) await sleep(1500);
      else throw error;
    }
  }
};

// POST com retry automático
const postForm = async (formData, tentativas = 3) => {
  for (let i = 0; i < tentativas; i++) {
    try {
      const params = new URLSearchParams();
      for (const [key, value] of formData.entries()) {
        params.append(key, value);
      }
      const response = await fetch(GAS_URL, {
        method: 'POST',
        redirect: 'follow',
        body: params,
        signal: AbortSignal.timeout(30000),
      });
      const text = await response.text();
      if (text.trim().startsWith('<')) {
        throw new Error('GAS retornou HTML — cold start');
      }
      return JSON.parse(text);
    } catch (error) {
      console.warn(`[API] POST tentativa ${i + 1}/${tentativas} falhou:`, error.message);
      if (i < tentativas - 1) await sleep(1500);
      else throw error;
    }
  }
};

// ── Conteúdo institucional ──────────────────────────────────────────────────
export const getInstitucional = () => request('getInstitucional');
export const updateInstitucional = (dados) => request('updateInstitucional', dados);

// ── Sacramentos ─────────────────────────────────────────────────────────────
export const getSacramentos = () => request('getSacramentos');
export const updateSacramento = (dados) => request('updateSacramento', dados);

// ── Capelas ─────────────────────────────────────────────────────────────────
export const getCapelas = () => request('getCapelas');
export const getCapela = (id) => request('getCapela', { id });
export const createCapela = (dados) => request('createCapela', dados);
export const updateCapela = (dados) => request('updateCapela', dados);
export const deleteCapela = (id) => request('deleteCapela', { id });

// ── Turmas de Batismo ───────────────────────────────────────────────────────
export const getTurmasBatismo = () => request('getTurmasBatismo');
export const createTurmaBatismo = (dados) => request('createTurmaBatismo', dados);
export const updateTurmaBatismo = (dados) => request('updateTurmaBatismo', dados);
export const deleteTurmaBatismo = (id) => request('deleteTurmaBatismo', { id });

// ── Inscrições de Batismo ───────────────────────────────────────────────────
export const getInscricoesBatismo = () => request('getInscricoesBatismo');
export const createInscricaoBatismo = (dados) => request('createInscricaoBatismo', dados);
export const updateStatusBatismo = (id, status) => request('updateStatusBatismo', { id, status });

// ── Turmas de Noivos ────────────────────────────────────────────────────────
export const getTurmasNoivos = () => request('getTurmasNoivos');
export const createTurmaNoivos = (dados) => request('createTurmaNoivos', dados);
export const updateTurmaNoivos = (dados) => request('updateTurmaNoivos', dados);
export const deleteTurmaNoivos = (id) => request('deleteTurmaNoivos', { id });

// ── Inscrições de Noivos ────────────────────────────────────────────────────
export const getInscricoesNoivos = () => request('getInscricoesNoivos');
export const createInscricaoNoivos  = (dados) => request('createInscricaoNoivos', dados);
export const updateStatusNoivos = (id, status) => request('updateStatusNoivos', { id, status });

// ── Solicitações ────────────────────────────────────────────────────────────
export const getSolicitacoes = () => request('getSolicitacoes');
export const createSolicitacao = (dados) => request('createSolicitacao', dados);
export const updateStatusSolicitacao = (id, status) => request('updateStatusSolicitacao', { id, status });

// ── Autenticação ────────────────────────────────────────────────────────────
export const login = (usuario, senha) => request('login', { usuario, senha });

// ── Dashboard ───────────────────────────────────────────────────────────────
export const getDashboard = () => request('getDashboard');

// ── Informativos ────────────────────────────────────────────────────────────
export const getInformativos = () => request('getInformativos');
export const createInformativo = (dados) => request('createInformativo', dados);
export const updateInformativo = (dados) => request('updateInformativo', dados);
export const deleteInformativo = (id) => request('deleteInformativo', { id });

// ── Dízimo ──────────────────────────────────────────────────────────────────
export const cadastrarDizimista = (dados) => request('cadastrarDizimista', dados);
export const getDizimistas = () => request('getDizimistas');